import { useState } from "react";

import { WithHeightTransition } from "../../../../../../HOC/WithHeightTransition";
import {
  actions,
  useAppDispatch,
  useAppSelector,
} from "../../../../../../redux";
import { Modal } from "../../../../../Common";
import {
  FlexColumn,
  FlexColumnWithTransition,
} from "../../../../../Common/Styles";
import CircleModalProps from "./CircleModal";
import ModalContent from "./ModalContent";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";

const CircleModal = ({ modalOpen }: CircleModalProps.IProps) => {
  const dispatch = useAppDispatch();
  const { listOfCircles, editCircleId } = useAppSelector(
    (state) => state.circle
  );
  const editCircle = listOfCircles.find((circle) => circle.id === editCircleId);
  const [color, setColor] = useState(
    editCircle?.colour ? editCircle.colour : "#5D0EF5"
  );
  const [circleName, setCircleName] = useState(
    editCircle?.name ? editCircle.name : ""
  );
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);

  return (
    <Modal
      from="create-circle"
      type="Pages"
      modalOpen={modalOpen}
      maxWidth={478}
      showCloseButton
      setCloseButton={() => {
        dispatch(
          actions.circle.setCreateCircleOpen({ createCircleOpen: false })
        );
        dispatch(actions.circle.setCreateCircle_API_STATUS("idle"));
      }}
    >
      <FlexColumnWithTransition $height={containerHeight}>
        <WithHeightTransition setContainerHeight={setContainerHeight}>
          <FlexColumn $gapInPx={16}>
            <ModalHeader
              isSuccessModal={isSuccessModal}
              circleName={circleName}
            />
            <ModalContent
              color={color}
              setColor={setColor}
              setCircleName={setCircleName}
              circleName={circleName}
              isSuccessModal={isSuccessModal}
            />
            {!isSuccessModal && (
              <ModalFooter
                circleName={circleName}
                setIsSuccessModal={setIsSuccessModal}
                color={color}
              />
            )}
          </FlexColumn>
        </WithHeightTransition>
      </FlexColumnWithTransition>
    </Modal>
  );
};

export default CircleModal;
